import { fontSize, lineHeight, styled } from "@mui/system";
import COLORS from "../../../theme/Colors";
import { TextField, Button } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SearchIcon from "@mui/icons-material/Search";
import { Translate } from "@mui/icons-material";
import FONTS_FAMILY from "../../../theme/FontsFamily";
import { StyledTextInput } from "../../../theme/Styles";
import VideoImage from '../../../assets/images/videoImage.png'

export const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  overflowX: "hidden",
});

// Wraps both Header and HomeContainer so they shift together when topbar expands
export const HeroWrapper = styled("div")({
  position: "relative",
  transition: "margin-top 0.3s ease",
});

export const HomeContainer = styled("div")((props) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  minHeight: "100vh",
  background: `url(${props.image})`,
  backgroundSize: "cover",
  boxShadow: "inset 0 0 0 2000px rgba(0, 0, 0, 0.5)",
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center'
}));

export const HomeCenterContent = styled("div")((props) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '600px',
  alignItems: 'center',
  justifyContent: 'center'

}));

export const ContainerVideo = styled("div")(props => ({
  position: 'relative',
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: '1920px',
  alignSelf: 'center',
  minHeight: "100vh",
  justifyContent: "center",
}));

export const VideoOverlay = styled("div")(props => ({
  position: 'absolute',
  backgroundImage: `url(${VideoImage})`,
  display: props.display,
  flexDirection: "column",
  width: "100%",
  maxWidth: '1920px',
  alignSelf: 'center',
  minHeight: "100vh",
  justifyContent: "center",
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  "&:hover": {
    cursor: 'pointer',
    boxShadow: "inset 0 0 0 2000px rgba(0, 0, 0, 0.1)",
  },
}));

export const MediumContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  justifyContent: "center",
  "@media (min-width:360px)": {
    minHeight: "270px",
  },
  "@media (min-width:768px)": {
    minHeight: "300px",
  },
  "@media (min-width:1200px)": {
    minHeight: "600px",
  },
});

export const HomeTextContainer = styled("div")({
  display: 'flex',
  flexDirection: "column",
  position: "relative",
  marginLeft: "15%",
  marginTop: "8%",
  height: "500px",
  alignSelf: "center",
  fontSize: "15px",
  width: "100%",
  justifyContent: 'center'
});

export const DefaultButton = styled(Button)({
  color: COLORS.white,
  backgroundColor: COLORS.primary,
  borderRadius: "20px",
  fontSize: "15px !important",
  fontFamily: `${FONTS_FAMILY.regular.body} !important`,
  height: '38px',
  "&:hover,&:focus,&:active": {
    color: COLORS.white,
    backgroundColor: COLORS.black,
  },
  "@media (min-width:320px)": {
    width: "180px",
  },
  "@media (min-width:768px)": {
    width: "230px",
  },
  "@media (min-width:1200px)": {
    width: "230px",
  },
});

export const HomeTitle = styled("h1")({
  zIndex: 10,
  width: "55%",
  color: COLORS.white,
  fontFamily: FONTS_FAMILY.regular.title,
  fontWeight: 700,
  textAlign: 'left',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  "@media (min-width:320px)": {
    fontSize: "22px",
    height: "280px",
    WebkitLineClamp: 8, /* number of lines to show */
  },
  "@media (min-width:768px)": {
    fontSize: "28px",
    WebkitLineClamp: 6, /* number of lines to show */
    height: "250px",
  },
  "@media (min-width:1200px)": {
    fontSize: "45px",
    height: "200px",
    WebkitLineClamp: 5, /* number of lines to show */
  },
});



export const Section = styled("section")({
  marginBlock: "0.67em",
  overflowX: "",
  position: "absolute",
  display: "inline-block",
  top: "30%",
  left: "20%",
  zIndex: 30,
  justifyContent: "center",
  flexDirection: "column",
  /* test*/
  height: "500px",
  textDecoration: "none",
  minHeight: "300px",
  width: "50%",
  "@media (max-width:360px)": {
    fontSize: "8px",
    display: "block",
  },
  "@media (min-width:768px)": {
    fontSize: "14px",
    top: "30%",
    left: "20%",
  },
  "@media (min-width:1200px)": {
    fontSize: "18px",
  },
  "@media (min-width:2048px)": {
    fontSize: "30px",
  },
  "@media (min-width:3840px)": {
    fontSize: "55px",
  },
});

export const StyledDescriptionIcon = styled(DescriptionIcon)({
  color: COLORS.primary,
  "@media (min-width:320px)": {
    fontSize: "50px",
  },
  "@media (min-width:768px)": {
    fontSize: "70px",
  },
  "@media (min-width:1200px)": {
    fontSize: "100px",
  },
});

export const StyledPersonAddIcon = styled(PersonAddIcon)({
  color: COLORS.primary,
  "@media (min-width:320px)": {
    fontSize: "50px",
  },
  "@media (min-width:768px)": {
    fontSize: "70px",
  },
  "@media (min-width:1200px)": {
    fontSize: "100px",
  },
});

export const StyledSearchIcon = styled(SearchIcon)({
  color: COLORS.primary,
  "@media (min-width:320px)": {
    fontSize: "50px",
  },
  "@media (min-width:768px)": {
    fontSize: "70px",
  },
  "@media (min-width:1200px)": {
    fontSize: "100px",
  },
});

export const Title = styled("h1")({
  wordWrap: 'break-word',
  margin: 0,
  textAlign: "center",
  color: COLORS.white,
  fontFamily: FONTS_FAMILY.bold.title,
  fontWeight: 700,
  "@media (min-width:320px)": {
    fontSize: "28px",
  },
  "@media (min-width:768px)": {
    fontSize: "38px",
  },
  "@media (min-width:1200px)": {
    fontSize: "45px",
  },
});

export const SubTitle = styled("h3")({
  margin: 0,
  textAlign: "center",
  color: COLORS.white,
  fontFamily: FONTS_FAMILY.bold.title,
  fontWeight: 400,
  "@media (min-width:320px)": {
    fontSize: "14px",
  },
  "@media (min-width:768px)": {
    fontSize: "16px",
  },
  "@media (min-width:1200px)": {
    fontSize: "18px",
  },
});

export const SearcherSubTitle = styled("p")({
  color: COLORS.secondary,
  textAlign: "center",
  marginBottom: "10px",
  alignSelf: 'center',
  fontFamily: FONTS_FAMILY.regular.body,
  "@media (min-width:320px)": {
    fontSize: "15px",
    width: '350px',
  },
  "@media (min-width:768px)": {
    fontSize: "15px",
    width: '500px',
  },
  "@media (min-width:1200px)": {
    fontSize: "16px",
    width: '700px',
  },
});

export const SearcherTitle = styled("h3")({
  color: COLORS.secondary,
  margin: "0",
  textAlign: "center",
  fontSize: "30px",
  fontFamily: FONTS_FAMILY.regular.title,
  "@media (max-width:768px)": {
    fontSize: "23px",
  },
});

export const AnalyticsContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignSelf: "center",
  width: "100%",
  maxWidth: "1920px",
  justifyContent: "space-evenly",
  paddingBottom: "50px",
  "@media (max-width: 768px)": {
    flexDirection: "column",
    alignItems: "center",
    gap: "60px",
  },
});

export const StatsHeader = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingTop: "20px",
  paddingBottom: "80px",
  width: "100%",
});

export const StatsTitle = styled("h2")({
  color: COLORS.white,
  fontSize: "36px",
  fontFamily: FONTS_FAMILY.bold.title,
  margin: "0 0 10px 0",
  "@media (max-width: 768px)": {
    fontSize: "28px",
  },
});

export const StatsDescription = styled("p")({
  color: "rgba(255, 255, 255, 0.8)",
  fontSize: "18px",
  fontFamily: FONTS_FAMILY.regular.body,
  maxWidth: "800px",
  margin: "0",
  lineHeight: "1.6",
  "@media (max-width: 768px)": {
    fontSize: "16px",
    width: "90%",
  },
});

export const SearcherContainer = styled("div")({
  borderRadius: '10px',
  "@media (min-width:320px)": {
    width: '300px',
  },
  "@media (min-width:768px)": {
    width: '600px',
  },
  "@media (min-width:1200px)": {
    width: '800px',
  },
});

export const SelectorContainer = styled("div")({
  width: "100%",
  alignItems: "flex-start",
  alignSelf: "center",
  padding: "1%",
});

export const StyledSearchIconForSearcher = styled(SearchIcon)({
  color: COLORS.white
});

export const SearchTextInput = styled(TextField)({
  width: '100%',
  alignSelf: 'center',
  borderWidth: '5px',
  color: COLORS.white,
  '& .MuiInputBase-input ': {
    width: '100%',
    fontSize: '17px',
    //   backgroundColor: COLORS.white,
    padding: 10,
    color: COLORS.white,
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: COLORS.white,
      borderRadius: '50px',
      minHeight: '45px',
      color: COLORS.white,
    },
    '&:hover fieldset': {
      borderColor: COLORS.white,
      color: COLORS.white,
    },
    '&.Mui-focused fieldset': {
      borderColor: COLORS.white,
      borderWidth: '1px',
    },
  },
});

export const ServicesListContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  width: "100%",
  minHeight: "100vh",
});

export const WhiteTitle = styled("h1")({
  margin: "10px",
  fontSize: "50px",
  textAlign: "center",
  color: COLORS.white,
  fontFamily: FONTS_FAMILY.regular.title,
  fontWeight: 700,
  "@media (min-width:320px)": {
    fontSize: "38px",
  },
  "@media (min-width:768px)": {
    fontSize: "45px",
  },
  "@media (min-width:1200px)": {
    fontSize: "55px",
  },
});

export const WhiteSubtitle = styled("h1")({
  margin: "10px",
  fontSize: "20px",
  textAlign: "center",
  color: COLORS.white,
  fontFamily: FONTS_FAMILY.regular.body,
  //  textShadow: '2px 2px 10px #000000',
  "@media (max-width:768px)": {
    fontSize: "20px",
  },
});

export const CenterContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "68%",
  maxWidth: "1920px",
  alignSelf: "center",
  padding: "10px",
  overflow: "hidden",
  "@media (max-width:768px)": {
    width: "90%",
  },
});

export const CardsContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  "@media (min-width:320px)": {
    flexDirection: "column",
  },
  "@media (min-width:768px)": {
    flexDirection: "row",
  },
  "@media (min-width:1200px)": {
    flexDirection: "row",
  },
});

export const CardsDivider = styled("div")({
  "@media (min-width:320px)": {
    height: "25px",
  },
  "@media (min-width:768px)": {
    width: "10%",
  },
  "@media (min-width:1200px)": {
    width: "10%",
  },
});

export const AnalyticItem = styled("div")((props) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}));

export const AnalyticItemIcon = styled("div")((props) => ({
  display: 'flex',
  alignSelf: 'center',
  width: '90px',
  height: '90px',
  marginBottom: '25px',
 
}));

// SECCIÓN TESTIMONIOS
export const TestimonialsWrapper = styled("div")({
  backgroundColor: '#F8FAFC',
  padding: '100px 0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  position: 'relative',
  zIndex: 10, // Evita que divs inferiores se superpongan
  '& .swiper-pagination': {
    bottom: '5px !important', // Obliga a los puntitos a bajar hacia el espacio extra del padding
  }
});

export const TestimonialCard = styled("div")({
  position: 'relative',
  backgroundColor: COLORS.white,
  padding: '18px 20px',
  borderRadius: '16px',
  boxShadow: '0 4px 12px rgba(15,35,80,0.04)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  border: '1px solid #E1E9EC',
  textAlign: 'left',
  margin: '10px 0',
  transition: 'all 0.3s ease',
  overflow: 'hidden',
  zIndex: 1,
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 12px 24px rgba(15,35,80,0.08)',
  }
});

export const TestimonialQuote = styled("div")({
  position: 'absolute',
  top: '15px',
  right: '20px',
  color: COLORS.primary,
  opacity: 0.15,
  fontSize: '70px',
  fontFamily: 'serif',
  lineHeight: 1,
  zIndex: -1,
  userSelect: 'none',
  transition: 'all 0.3s ease',
  '.TestimonialCard:hover &': {
    opacity: 0.25,
    transform: 'scale(1.1)',
  }
});

export const TestimonialContent = styled("p")({
  fontFamily: FONTS_FAMILY.regular.body,
  fontSize: '13.5px',
  lineHeight: '1.5',
  color: '#334155',
  margin: '4px 0 10px 0',
  padding: 0,
  position: 'relative',
  zIndex: 2,
  display: '-webkit-box',
  WebkitLineClamp: 4,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const TestimonialAuthorContainer = styled("div")({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  textAlign: 'left',
  gap: '10px',
  borderTop: '1px solid #F1F5F9',
  paddingTop: '10px',
  marginTop: 'auto',
});

export const TestimonialAuthor = styled("h4")({
  fontFamily: FONTS_FAMILY.bold.title,
  fontSize: '16px', // Más pequeño
  color: COLORS.primary, // Color institucional
  margin: '0 0 2px 0',
});

export const TestimonialRole = styled("span")({
  fontFamily: FONTS_FAMILY.regular.body,
  fontSize: '12px', // Más pequeño
  color: COLORS.secondary, // Color institucional
  fontWeight: 500,
  textTransform: 'uppercase',
});